import getLocalString from "constants/Localization";
import { useGetReportProposalDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportProposalDetails = (showSuccessMessage: boolean = true) => {
  const [mutation, { loading, data, error }] = useGetReportProposalDetailsMutation();
  const [getReportProposalDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportProposalDetails",
    },
    showSuccessMessage
    ? {
        successMessage: getLocalString("organization.generate-report-success"),
        failureMessage: getLocalString("organization.generate-report-failure"),
      }
    : {
        hideMessage: true,
      }
      
    
  );

  return [getReportProposalDetails, { ...context, data }] as const;
};

export default useGetReportProposalDetails;
